import Icon from "@ant-design/icons";

const WadingPoolSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M2027 4452 l-287 -287 0 -998 0 -997 145 0 145 0 0 95 0 95 505 0
   505 0 0 -95 0 -95 145 0 145 0 0 942 0 943 242 242 243 243 -103 102 -102 103
   -285 -285 -285 -285 0 -202 0 -203 -505 0 -505 0 0 137 0 138 245 245 245 245
   -103 103 -102 102 -288 -288z m1011 -1109 l3 -133 -506 0 -505 0 0 128 c0 71
   3 132 7 135 3 4 230 6 502 5 l496 -3 3 -132z m0 -555 l-3 -133 -500 0 -500 0
   -3 133 -3 132 506 0 506 0 -3 -132z"
      />
      <path
        d="M463 2822 l-462 -387 0 -610 -1 -610 460 -417 459 -418 1641 0 1641
   0 459 418 460 417 0 611 0 610 -27 21 c-16 11 -224 185 -463 387 l-434 366
   -368 0 -368 0 0 -145 0 -145 315 0 314 0 330 -276 330 -277 -92 -77 c-51 -43
   -200 -168 -332 -279 l-240 -201 -1525 0 -1525 1 -331 277 -332 277 42 36 c22
   20 171 145 329 278 l289 241 289 0 289 0 0 145 0 145 -342 0 -343 0 -462 -388z
   m116 -1007 l251 -210 0 -373 0 -373 -23 18 c-13 10 -134 119 -270 243 l-247
   225 0 354 c0 347 0 353 19 340 11 -8 132 -108 270 -224z m4251 -118 l0 -353
   -247 -224 c-136 -124 -257 -233 -270 -243 l-23 -18 0 373 1 373 266 223 c147
   122 268 222 270 222 2 0 3 -159 3 -353z m-830 -602 l0 -425 -1440 0 -1440 0 0
   425 0 425 1440 0 1440 0 0 -425z"
      />
    </g>
  </svg>
);

const WadingPoolIcon = (props) => <Icon component={WadingPoolSvg} {...props} />;

export default WadingPoolIcon;
